import base from './base.yaml'
import docs from './docs'
import server from './server'
import settings from './settings.yaml'
import stage from './stage.yaml'
import tamagotchi from './tamagotchi'

export default {
  base,
  docs,
  server,
  settings,
  stage,
  tamagotchi,
}
